import { render } from "./FormInput.vue?vue&type=template&id=255c2cb7&scoped=true&ts=true"
import script from "./FormInput.vue?vue&type=script&lang=ts"
export * from "./FormInput.vue?vue&type=script&lang=ts"

import "./FormInput.vue?vue&type=style&index=0&id=255c2cb7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255c2cb7"]])

export default __exports__